import { MODULE_REGISTRY, getModuleById, } from "@/navigation/activitiesRegistry";
import { canActAsMiembroDirectiva, canActAsTreasurer, } from "@/utils/courseRoles";
import { isCpaCourse, isCpaDirectiva, isFuncionariosCourse, isKioskCourse, } from "@/utils/parseCourseCode";
const CHROME_MODULE_IDS = new Set(["home-summary", "cpa-home"]);
const CPA_BOARD_DEFAULTS = [
    "courses-boards",
    "staff",
    "cpa-socios",
    "asignaciones",
    "school-life",
    "calendar",
    "suppliers",
    "tournaments",
    "cpa-mass-email",
    "website",
    "galleries",
    "cpa-board",
];
const COURSE_BOARD_DEFAULTS = [
    "surveys",
    "asignaciones",
    "manage-sales",
    "manage-donations",
    "mass-email",
    "association-link",
    "edit-board",
];
const GUARDIAN_DEFAULTS = ["sales", "donations", "asignaciones"];
const TREASURER_EXTRA = [
    "treasury-validate-payments",
    "manage-sales",
    "manage-donations",
];
export const isConfigurableModule = (mod) => mod.userCanPin && !CHROME_MODULE_IDS.has(mod.id);
export const isGroupConfigurableModule = (mod) => {
    if (!mod.configurableByGroup || CHROME_MODULE_IDS.has(mod.id))
        return false;
    if (mod.section === "treasury" &&
        mod.id !== "treasury" &&
        mod.id !== "bank-statements") {
        return false;
    }
    return true;
};
export const isTreasuryEnabled = (settings) => settings.treasury.enabled !== false;
export const isGroupModuleEnabled = (mod, settings) => {
    if (mod.id === "treasury") {
        return isTreasuryEnabled(settings);
    }
    if (mod.id === "bank-statements") {
        return (isTreasuryEnabled(settings) && settings.treasury.bankStatements !== false);
    }
    if (mod.section === "treasury") {
        return isTreasuryEnabled(settings);
    }
    if (settings.modules[mod.id] === false)
        return false;
    if (settings.modules[mod.id] === true)
        return true;
    return mod.groupDefaultEnabled !== false;
};
export const listAvailableModules = (ctx, settings) => MODULE_REGISTRY.filter((mod) => isConfigurableModule(mod) &&
    mod.canAccess(ctx) &&
    isGroupModuleEnabled(mod, settings));
export const listGroupConfigurableModules = (ctx) => MODULE_REGISTRY.filter((mod) => {
    if (!isGroupConfigurableModule(mod))
        return false;
    if (!mod.availableFor?.length)
        return true;
    if (isCpaCourse(ctx.curso))
        return mod.availableFor.includes("cpa");
    if (isFuncionariosCourse(ctx.curso)) {
        return mod.availableFor.includes("funcionarios");
    }
    if (isKioskCourse(ctx.curso))
        return mod.availableFor.includes("kiosk");
    return mod.availableFor.includes("course");
});
export const defaultPinnedModuleIds = (ctx, available) => {
    const availableIds = new Set(available.map((mod) => mod.id));
    const wanted = [];
    if (isCpaDirectiva(ctx.curso)) {
        wanted.push(...CPA_BOARD_DEFAULTS);
    }
    else if (!isCpaCourse(ctx.curso) &&
        canActAsMiembroDirectiva(ctx.curso, ctx.userEmail)) {
        wanted.push(...COURSE_BOARD_DEFAULTS);
    }
    else {
        wanted.push(...GUARDIAN_DEFAULTS);
    }
    if (canActAsTreasurer(ctx.curso, ctx.userEmail)) {
        wanted.push(...TREASURER_EXTRA);
    }
    return [...new Set(wanted)].filter((id) => availableIds.has(id));
};
export const listVisibleModules = (available, pinnedIds, ctx) => {
    const visibleIds = new Set(pinnedIds ?? defaultPinnedModuleIds(ctx, available));
    return available.filter((mod) => visibleIds.has(mod.id));
};
export const isBankStatementsVisible = (settings) => isTreasuryEnabled(settings) && settings.treasury.bankStatements !== false;
const isHubPinnableModule = (mod) => isConfigurableModule(mod) && mod.surfaces.includes("hub");
export const isDrawerOptionVisible = (option, ctx) => {
    const moduleId = option.moduleId;
    if (!moduleId)
        return true;
    const mod = getModuleById(moduleId);
    if (!mod)
        return true;
    if (!isGroupModuleEnabled(mod, ctx.groupSettings))
        return false;
    if (ctx.skipPersonalPins)
        return true;
    if (!isHubPinnableModule(mod))
        return true;
    return ctx.visibleIds.has(mod.id);
};
export const filterDrawerGroupsByVisibility = (groups, ctx) => groups
    .map((group) => ({
    ...group,
    opciones: (group.opciones || []).filter((option) => isDrawerOptionVisible(option, ctx)),
}))
    .filter((group) => (group.opciones || []).length > 0);
